import { lazy } from "react";

// CUENTAS
const CuentasNegocioLayout = lazy(() =>
      import("../../cuentas_negocio/CuentasNegocioLayout.jsx")
);

const CuentasNegocioList = lazy(() =>
      import("../../cuentas_negocio/CuentasNegocioList.jsx")
);

const CuentaNegocioForm = lazy(() =>
      import("../../cuentas_negocio/CuentaNegocioForm.jsx")
);

const CuentasPorCobrar = lazy(() =>
      import("../../cuentas_x_cobrar/CuentasPorCobrar.jsx")
);

const Fiados = lazy(() =>
      import("../../cuentas_x_cobrar/Fiados.jsx")
);

// MÓDULO FINANZAS (dashboard + cuentas por pagar + calendario)
const FinanzasLayout = lazy(() =>
      import("../../finanzas/FinanzasLayout.jsx")
);

const FinanzasDashboard = lazy(() =>
      import("../../finanzas/FinanzasDashboard.jsx")
);

const CuentasPorPagar = lazy(() =>
      import("../../finanzas/CuentasPorPagar.jsx")
);

const CalendarioPagos = lazy(() =>
      import("../../finanzas/CalendarioPagos.jsx")
);

const CarteraCheques = lazy(() =>
      import("../../finanzas/CarteraCheques.jsx")
);

// GASTOS (🔥 ahora correctamente en finanzas)
const GastosLayout = lazy(() =>
      import("../../gastos/GastosLayout.jsx")
);

const Gastos = lazy(() =>
      import("../../gastos/Gastos.jsx")
);

const GastoForm = lazy(() =>
      import("../../gastos/GastoForm.jsx")
);

const finanzasRoutes = [
      // 📊 FINANZAS (dashboard, por pagar, calendario)
      {
            path: "finanzas",
            element: <FinanzasLayout />,
            children: [
                  { index: true, element: <FinanzasDashboard /> },
                  { path: "fiados", element: <Fiados /> },
                  { path: "por-pagar", element: <CuentasPorPagar /> },
                  { path: "calendario", element: <CalendarioPagos /> },
                  { path: "cheques", element: <CarteraCheques /> },
            ],
      },

      // 💰 CUENTAS NEGOCIO
      {
            path: "cuentas-negocio",
            element: <CuentasNegocioLayout />,
            children: [
                  { index: true, element: <CuentasNegocioList /> },
                  { path: "form", element: <CuentaNegocioForm /> },
            ],
      },

      // 💳 CUENTAS POR COBRAR
      {
            path: "cuentas-por-cobrar",
            element: <CuentasPorCobrar />,
      },
      {
            path: "cuentas-por-cobrar/:token",
            element: <CuentasPorCobrar />,
      },

      // 💸 GASTOS
      {
            path: "gastos",
            element: <GastosLayout />,
            children: [
                  { index: true, element: <Gastos /> },
                  { path: "nuevo", element: <GastoForm /> },
                  { path: "editar", element: <GastoForm /> },
            ],
      },
];

export default finanzasRoutes;